/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CabinClass {
    First = 'First',
    Business = 'Business',
    PremiumEconomy = 'PremiumEconomy',
    Economy = 'Economy'
}

export function CabinClassFromJSON(json: any): CabinClass {
    return CabinClassFromJSONTyped(json, false);
}

export function CabinClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClass {
    return json as CabinClass;
}

export function CabinClassToJSON(value?: CabinClass | null): any {
    return value as any;
}

